import { fetchWithTokenRefresh } from './AuthActions';
import { getUsers, getCurrentUser } from './UsersActions';

import {
  shoutout_feed_initialized,
  shoutouts_returned,
  shoutouts_before_returned,
  new_shoutout_received,
  all_shoutouts_loaded,
  shoutouts_requested,
  shoutout_returned,
  profile_shoutout_returned,
  show_image,
  shoutout_deleted,
  shoutout_updated
} from './types';
import env from '../globals/environment';
import socket from '../globals/socket';

const LIMIT = 20;

export const initShoutoutsFeed = () => {
  return dispatch => {
    dispatch({ type: shoutout_feed_initialized });
    dispatch(getShoutouts());
  };
};

export const getShoutouts = () => {
  return async (dispatch, getState) => {
    const { authStore, usersStore, shoutoutsStore } = getState();
    const { allShoutoutsLoaded, shoutoutsLoading, after } = shoutoutsStore;

    try {
      if (!shoutoutsLoading && !allShoutoutsLoaded) {
        dispatch({ type: shoutouts_requested });

        const { headers } = authStore;
        const { users } = usersStore;
        const response = await fetchWithTokenRefresh(`${env.backendUrl}/shoutouts?limit=${LIMIT}&after=${after}`, { headers })(dispatch);
        if (!response.ok) throw new Error('Could not get shoutouts from api');
        else {
          const data = await response.json();
          const { shoutouts, after } = data;
          if (shoutouts.length < LIMIT) {
            dispatch({ type: all_shoutouts_loaded });
          }
          dispatch({
            type: shoutouts_returned,
            payload: {
              after,
              shoutouts: shoutouts.map(shoutout => mapShoutoutToUsers(shoutout, users))
            }
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const getShoutoutById = (id, profile = null) => {
  return async (dispatch, getState) => {
    const { authStore, usersStore } = getState();
    const type = profile ? profile_shoutout_returned : shoutout_returned;
    try {
      const { headers } = authStore;
      const { users } = usersStore;
      const response = await fetchWithTokenRefresh(`${env.backendUrl}/shoutouts/${id}`, { headers })(dispatch);

      if (!response.ok) {
        console.log('Could not get a shoutout from api');
        dispatch({
          type,
          payload: null
        });
      }
      else {
        let shoutout = await response.json();
        if (profile && shoutout && shoutout.recipients.indexOf(profile) === -1) shoutout = null;
        if (shoutout) {
          dispatch({
            type,
            payload: mapShoutoutToUsers(shoutout, users)
          });
        } else {
          dispatch({
            type,
            payload: null
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const listenForShoutouts = () => {
  return (dispatch, getState) => {
    const { headers } = getState().authStore;
    socket.on('shoutout', async shoutout => {
      const { users, currentUser } = getState().usersStore;
      dispatch({
        type: new_shoutout_received,
        payload: mapShoutoutToUsers(shoutout, users)
      });
      if (shoutout.sender === currentUser._id || shoutout.recipients.indexOf(currentUser._id) !== -1) {
        dispatch(getCurrentUser(true));
      }
      await fetchWithTokenRefresh(`${env.backendUrl}/users/lastread`, { headers })(dispatch);
    });
    socket.on('shoutout-delete', async id => {
      const { shoutouts } = getState().shoutoutsStore;

      let shoutout = shoutouts.find((shoutout) => shoutout._id === id);
      if (shoutout === undefined) {
        shoutout = getState().profile.shoutouts.find((shoutout) => shoutout._id === id);
      }
      dispatch({ type: shoutout_deleted, payload: shoutout });
    });
    socket.on('shoutout-update', async shoutout => {
      dispatch({ type: shoutout_updated, payload: shoutout });
    });
  };
};

export const getShoutoutsBefore = before => {
  return async (dispatch, getState) => {
    try {
      const { authStore, usersStore, shoutoutsStore } = getState();
      const { allShoutoutsLoaded, shoutoutsLoading } = shoutoutsStore;

      if (!shoutoutsLoading && !allShoutoutsLoaded) {
        dispatch({ type: shoutouts_requested });

        const { headers } = authStore;
        const { users } = usersStore;

        let foundUsers;
        if (!users || !users.length) {
          await dispatch(getUsers());
          foundUsers = getState().usersStore.users;
        } else foundUsers = users;

        const url = `${env.backendUrl}/shoutouts?before=${before}&after=${new Date(Date.now()).toISOString()}`;
        const response = await fetchWithTokenRefresh(url, { headers })(dispatch);
        if (!response.ok) throw new Error('Could not get shoutouts from api');
        else {
          const data = await response.json();
          const shoutouts = data.shoutouts;

          dispatch({
            type: shoutouts_before_returned,
            payload: shoutouts.map(shoutout => mapShoutoutToUsers(shoutout, foundUsers))
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const createShoutout = (recipients, text, tags, image) => {
  return async (dispatch, getState) => {
    try {
      const { headers } = getState().authStore;
      const response = await fetchWithTokenRefresh(`${env.backendUrl}/shoutouts`, {
        method: 'POST',
        body: JSON.stringify({
          recipients,
          text,
          tags,
          image
        }),
        headers
      })(dispatch);

      if (!response.ok) throw new Error('Could not create new shoutout');
      else {
        const data = await response.json();

        if (!data.success) throw data;
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const mapShoutoutToUsers = (shoutout, users = []) => {
  shoutout = fixShoutout(shoutout);

  let recipients = shoutout.recipients.map(recipient => users.find(user => user.uid === recipient));
  // if (!recipient) recipient = teams.find(team => team.key === shoutout.recipientId);

  // shoutout.recipient = recipient;
  shoutout.recipients = recipients;
  shoutout.sender = users.find(user => user.uid === shoutout.senderId);

  if (!shoutout.recipient) {
  //  console.log('Could not find recipient', shoutout, users);
  }

  if (!shoutout.sender) {
    //console.log('Could not find sender', shoutout, users);
    console.log(1);
  }

  return shoutout;
};

export const getImage = (id) => {
  return `${env.backendUrl}/shoutouts/images/${id}`;
};

export const showFullscreenImage = (url) => {
  return { type: show_image, payload: url };
};

export const deleteShoutout = (id) => {
  return async (dispatch, getState) => {
    try {
      console.log('deleteing this so');
      const { headers } = getState().authStore;
      const response = await fetchWithTokenRefresh(`${env.backendUrl}/shoutouts/${id}`, { method: 'DELETE', headers })(dispatch);
      if (!response.ok) throw new Error('Could not delete shoutout');
    } catch (error) {
      console.log(error);
    }
  };
};

const fixShoutout = shoutout => {
  let fixedShoutout = { ...shoutout };
  fixedShoutout.date = shoutout.timestamp;
  fixedShoutout.message = shoutout.text;
  fixedShoutout.senderId = shoutout.senderId || shoutout.sender;
  if (shoutout.image) {
    fixedShoutout.imageUrl = getImage(shoutout.image);
    const preview = `${shoutout.image.split('.')[0]}_preview.${shoutout.image.split('.')[1]}`;
    fixedShoutout.previewImageUrl = getImage(preview);
  }

  return fixedShoutout;
};



// WEBPACK FOOTER //
// ./src/actions/ShoutoutsActions.js